import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ChartConfiguration, ChartData, TooltipItem } from 'chart.js';
// import { TimeentryDB } from 'src/app/store/application';
import { BaseChartDirective } from 'ng2-charts';
import { TimeBank } from 'src/app/models/timeBank';
import {
  BankType,
  PayPeriod,
  PayPeriodEntry,
  Timesheet,
  TimesheetEntryType,
  TimesheetStatus,
  ExceptionType,
  TimeentryDB,
} from 'src/app/store/application';
import { Profile } from 'src/app/models/profile';
import { BankType as TimeBankBankType } from 'src/app/models/timeBank';
import * as HelperFunctions from 'src/assets/helper-functions/helper-functions';

@Component({
  selector: 'app-time-bank',
  templateUrl: './time-bank.component.html',
  styleUrls: ['./time-bank.component.scss'],
})
export class TimeBankComponent implements OnChanges {
  @ViewChild('cdo') cdoChart?: BaseChartDirective;
  @ViewChild('holiday') holidayChart?: BaseChartDirective;
  @ViewChild('sick') sickChart?: BaseChartDirective;

  @Input() bankTypes: TimeBankBankType[] | null = [];
  @Input() timeBanks: TimeBank[] | null = [];
  @Input() timesheets: Timesheet[] = [];
  @Input() selectedYear: number | null = new Date().getFullYear();
  @Input() currentPayPeriod: PayPeriod | undefined;
  @Input() lastPayPeriod: PayPeriod | undefined;
  @Input() profile: Profile | undefined | null;
  @Input() exceptionTypes: ExceptionType[] | null = [];

  zeroTimeBank = { allocated: 0, taken: 0, carried: 0, booked: 0 } as TimeBank;
  holidayBank: TimeBank = {} as TimeBank;
  sickBank: TimeBank = {} as TimeBank;

  cdoBank: TimeBank = this.zeroTimeBank;
  otBankCurr: TimeBank = this.zeroTimeBank;
  otBankPrev: TimeBank = this.zeroTimeBank;
  statBank: TimeBank = this.zeroTimeBank;
  councilBank: TimeBank = this.zeroTimeBank;
  bankedAvailable = 0;
  bankedPlanned = 0;
  bankedTaken = 0;
  vacationUsed = 0;
  vacationEntitlement = 0;
  vacationRemaining = 0;
  vacationCarried = 0;
  sickUsed = 0;
  sickCarried = 0;
  sickRemaining = 0;
  sickEntitlement = 0;
  bankedTooltip = [] as string[];

  pendingVacation = 0;
  bankRelatedTimeEntries: TimeentryDB[] = [];
  usedBank: { [id: string]: number } = {};
  loadedTimeBanks: { [id: string]: TimeBank } = {};
  timebankLastDate: { [id: string]: Date } = {};

  currentDate = new Date();

  public cdoChartData: ChartData<'doughnut'> = {
    labels: ['Used', 'Planned', 'Available'],
    datasets: [
      {
        data: [1, 1, 1],
        backgroundColor: ['#009cde', '#80ceef', '#d7d7d7'],
        hoverBackgroundColor: ['#009cde', '#80ceef', '#d7d7d7'],
        borderWidth: 0,
      },
    ],
  };

  public holidayChartData: ChartData<'doughnut'> = {
    labels: ['Used', 'Available'],
    datasets: [
      // { data: [1, 1, 1], backgroundColor: ['#de4200', '#eea07f', '#d7d7d7'], hoverBackgroundColor: ['#de4200', '#eea07f', '#d7d7d7'], borderWidth: 0 }
      {
        data: [1, 1],
        backgroundColor: ['#de4200', '#eea07f'],
        hoverBackgroundColor: ['#de4200', '#eea07f'],
        borderWidth: 0,
      },
    ],
  };

  public sickChartData: ChartData<'doughnut'> = {
    labels: ['Used', 'Available'],
    datasets: [
      // { data: [1, 1], backgroundColor: ['#ab037a', '#d7d7d7'], hoverBackgroundColor: ['#ab037a', '#d7d7d7'], borderWidth: 0 }
      {
        data: [1, 1],
        backgroundColor: ['#ab037a', '#db9fca'],
        hoverBackgroundColor: ['#ab037a', '#db9fca'],
        borderWidth: 0,
      },
    ],
  };

  public doughnutChartOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            // console.log(context);
            let label = ' ' + context.formattedValue || '';

            if (label) {
              label += ' hrs';
            }
            return label;
          },
        },
      },
    },
  };

  bankedTimeOptions: ChartConfiguration<'doughnut'>['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '60%',
    plugins: {
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<'doughnut'>) => {
            console.log(context);
            console.log(this);
            let label = ' ' + context.formattedValue || '';
            if (context.label === 'Available') {
              return this.bankedTooltip;
            }

            if (label) {
              label += ' hrs';
            }
            return label;
          },
        },
      },
    },
  };

  isCollapse = true;

  ngOnChanges(changes: SimpleChanges): void {
    const today = new Date();
    // console.log('TimeBankComponent ngOnChanges');
    if (!!this.bankTypes && changes.bankTypes) {
      if (Object.keys(this.usedBank).length === 0) {
        (this.bankTypes as TimeBankBankType[]).forEach(
          (bt: TimeBankBankType) => {
            this.usedBank[bt.id] = 0;
            this.timebankLastDate[bt.id] = new Date(2000, 0, 1);
            this.loadedTimeBanks[bt.id] = this.zeroTimeBank;
          }
        );
      }
    }

    if (changes.selectedYear) {
      if (changes.selectedYear.currentValue === today.getFullYear()) {
        this.currentDate = today;
      } else if (changes.selectedYear.currentValue < today.getFullYear()) {
        this.currentDate = new Date(
          Number(changes.selectedYear.currentValue),
          11,
          31
        );
      }
    }

    if (
      !!this.profile &&
      !!this.exceptionTypes &&
      this.exceptionTypes.length > 0 &&
      (changes.timesheets ||
        changes.selectedYear ||
        changes.profile ||
        changes.exceptionTypes)
    ) {
      const year: number = this.selectedYear || today.getFullYear();
      let { pendingVacationYear, yearBankRelatedTimeEntries } =
        this.getCurrentBankCompilationInformation(year);
      this.pendingVacation = pendingVacationYear;
      this.bankRelatedTimeEntries = yearBankRelatedTimeEntries;

      // const usedBankTimesheetTypes = [TimesheetStatus.Deleted, TimesheetStatus.Predicted, TimesheetStatus.RolledBack].map(status => status.toString());

      // // get the timsheets that includes dates from current year
      // const timesheetsForYear = this.timesheets.filter(timesheet => timesheet.startDate.getFullYear() === year || timesheet.endDate.getFullYear() === year);
      // this.bankRelatedTimeEntries = [];

      // let timesheetsWithRightStatus = timesheetsForYear.filter(timesheet =>
      //   (timesheet.startDate >= this.currentPayPeriod!.startDate || (timesheet.submittedDateTime! >= this.currentPayPeriod!.startDate)) &&
      //   !usedBankTimesheetTypes.includes(timesheet.status));

      // timesheetsWithRightStatus.forEach(ts => {
      //   const usedBank = HelperFunctions.compileUsedEntries(this.bankRelatedTimeEntries, this.bankTypes);
      //   let t: TimeentryDB[] = HelperFunctions.createTimeEntries(ts, (this.profile as Profile).configuration, (this.exceptionTypes as ExceptionType[]), [], usedBank, [], {ignoreStatus: true}).prepTimeEntry;
      //   let tFiltered = t.filter(ts => ts.entryDate.getFullYear() === year);
      //   this.bankRelatedTimeEntries.push(...tFiltered);
      // });

      // this.pendingVacation = this.getPendingVacationForYear(timesheetsForYear, year);
    }

    if (
      (changes.timeBanks || changes.selectedYear) &&
      this.timeBanks !== null &&
      this.timeBanks?.length > 0
    ) {
      this.loadTimeBanks();

      // const chartData = [];
      // this.bankedTooltip = [];
      // this.bankedAvailable = 0;
      // this.bankedPlanned = 0;
      // this.bankedTaken = 0;

      // this.usedBank = HelperFunctions.compileUsedEntries(this.bankRelatedTimeEntries, this.bankTypes);

      // this.compileBankedTimeBank(this.loadedTimeBanks[BankType.CDO], 'CDO', this.usedBank[BankType.CDO]);
      // this.compileBankedTimeBank(this.loadedTimeBanks[BankType.OvertimePreviousYear], 'OT prior yr', this.usedBank[BankType.OvertimePreviousYear]);
      // this.compileBankedTimeBank(this.loadedTimeBanks[BankType.OvertimeCurrentYear], 'OT current yr', this.usedBank[BankType.OvertimeCurrentYear]);
      // this.compileBankedTimeBank(this.loadedTimeBanks[BankType.StatutoryHolidays], 'Stat holiday', this.usedBank[BankType.StatutoryHolidays]);
      // this.compileBankedTimeBank(this.loadedTimeBanks[BankType.CouncilOT], 'Council OT', this.usedBank[BankType.CouncilOT]);

      // chartData.push(this.bankedTaken);
      // chartData.push(this.bankedPlanned);
      // chartData.push(this.bankedAvailable - this.bankedTaken);

      // this.cdoChartData.datasets[0].data = chartData;
      // this.bankedAvailable = this.cdoChartData.datasets[0].data[2];

      // if (this.cdoChart) {
      //   this.cdoChart.update();
      // }

      this.holidayBank = this.loadedTimeBanks[BankType.Vacation];
      this.sickBank = this.loadedTimeBanks[BankType.Sick];
      this.compileBanks();
    }
  }

  loadTimeBanks() {
    let yearToSearch = this.selectedYear!;
    // if (this.timeBanks!.length > 0) {
    //   let currentDate = new Date();

    //   while (!this.timeBanks!.some(tb => new Date(tb.createdAt).getFullYear() === yearToSearch)) {
    //     if (yearToSearch > currentDate.getFullYear()) {
    //       yearToSearch--;
    //     }

    //     else if (yearToSearch < currentDate.getFullYear()) {
    //       yearToSearch++;
    //     }
    //   }
    // }

    this.timeBanks!.filter(
      (tb) => new Date(tb.createdAt).getFullYear() <= yearToSearch
    )
      .sort(
        (lhs, rhs) =>
          new Date(lhs.createdAt).getTime() - new Date(rhs.createdAt).getTime()
      )
      .forEach((tb) => {
        this.loadedTimeBanks[tb.bankTypeId] = tb;

        const createdAt = new Date(tb.createdAt);
        this.timebankLastDate[tb.bankTypeId] = createdAt;
        // if (this.timebankLastDate[tb.bankTypeId] < createdAt) {
        //   this.timebankLastDate[tb.bankTypeId] = createdAt;
        // }
      });
  }

  doubleDigitTotal(number: Number) {
    return Number(number.toFixed(2));
  }

  getPendingVacationForYear(timesheetsForYear: Timesheet[], year: number) {
    let pendTotal = 0;

    timesheetsForYear.forEach((timesheet) => {
      (timesheet.startDate >= this.currentPayPeriod!.startDate ||
        timesheet.submittedDateTime! >= this.currentPayPeriod!.startDate) &&
        timesheet.entries
          .filter(
            (entry) =>
              entry.name === TimesheetEntryType.VACATION &&
              (timesheet.status === TimesheetStatus.Saved ||
                timesheet.status === TimesheetStatus.Submitted ||
                timesheet.status === TimesheetStatus.Approved ||
                timesheet.status === TimesheetStatus.JDE)
          )
          .forEach((entry) =>
            entry.durations.forEach((duration, index) => {
              // only count if the day is within current year
              const thisDay = this.addDays(timesheet.startDate, index);
              if (thisDay.getFullYear() === year) {
                pendTotal += duration;
              }
            })
          );
    });

    return pendTotal;
  }

  getCurrentBankCompilationInformation(
    year: number = new Date().getFullYear()
  ) {
    const yearBankRelatedTimeEntries: TimeentryDB[] = [];
    const usedBankTimesheetTypes = [
      TimesheetStatus.Deleted,
      TimesheetStatus.Predicted,
      TimesheetStatus.RolledBack,
    ].map((status) => status.toString());
    const timesheetsForYear = this.timesheets.filter(
      (timesheet) =>
        timesheet.startDate.getFullYear() === year ||
        timesheet.endDate.getFullYear() === year
    );

    let timesheetsWithRightStatus = timesheetsForYear.filter(
      (timesheet) =>
        (timesheet.startDate >= this.currentPayPeriod!.startDate ||
          timesheet.submittedDateTime! >= this.currentPayPeriod!.startDate) &&
        !usedBankTimesheetTypes.includes(timesheet.status)
    );

    timesheetsWithRightStatus.forEach((ts) => {
      const usedBank = HelperFunctions.compileUsedEntries(
        yearBankRelatedTimeEntries,
        this.bankTypes
      );
      let t: TimeentryDB[] = HelperFunctions.createTimeEntries(
        ts,
        (this.profile as Profile).configuration,
        this.exceptionTypes as ExceptionType[],
        [],
        usedBank,
        [],
        { ignoreStatus: true }
      ).prepTimeEntry;
      let tFiltered = t.filter((ts) => ts.entryDate.getFullYear() === year);
      yearBankRelatedTimeEntries.push(...tFiltered);
    });

    let yearUsedBank = HelperFunctions.compileUsedEntries(
      yearBankRelatedTimeEntries,
      this.bankTypes
    );
    let pendingVacationYear = this.getPendingVacationForYear(
      timesheetsForYear,
      year
    );

    return { yearUsedBank, pendingVacationYear, yearBankRelatedTimeEntries };
  }

  compileBanks() {
    const { yearUsedBank, pendingVacationYear, yearBankRelatedTimeEntries } =
      this.getCurrentBankCompilationInformation();
    this.compileBankedTimeBanks(yearBankRelatedTimeEntries);
    this.compileVacationBank(pendingVacationYear);
    this.compileSickBank(yearUsedBank);
  }

  compileBankedTimeBanks(yearBankRelatedTimeEntries: TimeentryDB[]) {
    const chartData = [];

    // get the used bank for the selected year
    this.usedBank = HelperFunctions.compileUsedEntries(
      this.bankRelatedTimeEntries,
      this.bankTypes
    );
    this.runBankTimeCompilation(this.usedBank);

    if (this.selectedYear! > new Date().getFullYear()) {
      const currTaken = this.bankedTaken;
      const currPlanned = this.bankedPlanned;
      const currAvailable = this.bankedAvailable;
      const currTooltips = [...this.bankedTooltip];

      // get the used bank for the last JDE entry provided year
      let currentYearUsedBank = HelperFunctions.compileUsedEntries(
        yearBankRelatedTimeEntries,
        this.bankTypes
      );
      this.runBankTimeCompilation(currentYearUsedBank);

      // set the parameters needed to indicate the data for this year
      this.bankedTaken = currTaken;
      this.bankedPlanned = currPlanned;
      this.bankedTooltip = [...this.bankedTooltip, ...currTooltips];
      // this.bankedAvailable += currAvailable;
    }

    chartData.push(this.bankedTaken);
    chartData.push(this.bankedPlanned);
    chartData.push(this.bankedAvailable - this.bankedTaken);

    this.cdoChartData.datasets[0].data = chartData;
    this.bankedAvailable = this.cdoChartData.datasets[0].data[2];

    if (this.cdoChart) {
      this.cdoChart.update();
    }
  }

  runBankTimeCompilation(usedBank: { [id: string]: number }) {
    this.bankedTooltip = [];
    this.bankedAvailable = 0;
    this.bankedPlanned = 0;
    this.bankedTaken = 0;

    this.compileBankedTimeBank(
      this.loadedTimeBanks[BankType.CDO],
      'CDO',
      usedBank[BankType.CDO]
    );
    this.compileBankedTimeBank(
      this.loadedTimeBanks[BankType.OvertimePreviousYear],
      'OT prior yr',
      usedBank[BankType.OvertimePreviousYear]
    );
    this.compileBankedTimeBank(
      this.loadedTimeBanks[BankType.OvertimeCurrentYear],
      'OT current yr',
      usedBank[BankType.OvertimeCurrentYear]
    );
    this.compileBankedTimeBank(
      this.loadedTimeBanks[BankType.StatutoryHolidays],
      'Stat holiday',
      usedBank[BankType.StatutoryHolidays]
    );
    this.compileBankedTimeBank(
      this.loadedTimeBanks[BankType.CouncilOT],
      'Council OT',
      usedBank[BankType.CouncilOT]
    );
  }

  compileBankedTimeBank(timeBank: TimeBank, name: string, used: number) {
    this.bankedAvailable =
      this.bankedAvailable +
      timeBank.allocated +
      timeBank.carried -
      timeBank.booked +
      used;
    this.bankedPlanned = this.bankedPlanned + timeBank.booked;
    this.bankedTaken = this.bankedTaken + timeBank.taken;

    const balance =
      timeBank.allocated +
      timeBank.carried -
      timeBank.booked -
      timeBank.taken +
      used;
    if (balance > 0) {
      this.bankedTooltip.push(' ' + balance + ' hrs (' + name + ')');
    }
  }

  getOverlapDetails(year: number) {
    const usedBankTimesheetTypes = [
      TimesheetStatus.Deleted,
      TimesheetStatus.Predicted,
      TimesheetStatus.RolledBack,
    ].map((status) => status.toString());
    const yearBankRelatedTimeEntries: TimeentryDB[] = [];

    let timesheetsCurrYearPPInPrevYear = this.timesheets.filter(
      (ts) =>
        ts.payDate.getFullYear() === year &&
        ts.startDate.getFullYear() === year - 1
    );
    let timesheetsWithRightStatus = timesheetsCurrYearPPInPrevYear.filter(
      (timesheet) =>
        (timesheet.startDate >= this.currentPayPeriod!.startDate ||
          timesheet.submittedDateTime! >= this.currentPayPeriod!.startDate) &&
        !usedBankTimesheetTypes.includes(timesheet.status)
    );

    timesheetsWithRightStatus.forEach((ts) => {
      const usedBank = HelperFunctions.compileUsedEntries(
        yearBankRelatedTimeEntries,
        this.bankTypes
      );
      let t: TimeentryDB[] = HelperFunctions.createTimeEntries(
        ts,
        (this.profile as Profile).configuration,
        this.exceptionTypes as ExceptionType[],
        [],
        usedBank,
        [],
        { ignoreStatus: true }
      ).prepTimeEntry;
      let tFiltered = t.filter((ts) => ts.entryDate.getFullYear() !== year);
      yearBankRelatedTimeEntries.push(...tFiltered);
    });

    let vacationOverlap = this.getPendingVacationForYear(
      timesheetsCurrYearPPInPrevYear,
      year - 1
    );
    let sickOverLap = HelperFunctions.compileUsedEntries(
      yearBankRelatedTimeEntries,
      this.bankTypes
    )[BankType.Sick];

    return { vacationOverlap, sickOverLap };
  }

  compileVacationBank(pendingVacationCurrentYear: number) {
    let date = new Date();
    let vacationOverlap = this.getOverlapDetails(
      this.selectedYear!
    ).vacationOverlap;

    if (this.holidayBank && this.selectedYear) {
      this.vacationUsed = this.holidayBank.taken + this.pendingVacation;
      this.vacationCarried = this.holidayBank.carried - vacationOverlap;

      if (this.selectedYear <= date.getFullYear()) {
        this.vacationEntitlement = this.holidayBank.allocated;
        this.vacationRemaining = Number(
          (
            this.vacationEntitlement +
            this.vacationCarried -
            this.vacationUsed
          ).toFixed(2)
        );
      } else {
        // first set the default variables for the current year
        vacationOverlap = this.getOverlapDetails(
          date.getFullYear()
        ).vacationOverlap;

        let carried = this.holidayBank.carried - vacationOverlap;
        let used = this.holidayBank.taken - pendingVacationCurrentYear;
        this.vacationEntitlement = this.holidayBank.allocated;
        this.vacationRemaining = Number(
          (this.holidayBank.allocated + carried - used).toFixed(2)
        );

        // set the data entries for the selected year
        this.vacationEntitlement = 0;
        this.vacationUsed = this.pendingVacation;
        this.vacationCarried = this.vacationRemaining;
        this.vacationRemaining = Number(
          (this.vacationCarried - this.pendingVacation).toFixed(2)
        );
      }
    }

    this.holidayChartData.datasets[0].data = [
      this.vacationUsed,
      this.vacationRemaining,
    ];
    this.holidayChartData.labels = ['Used', 'Available'];

    if (this.holidayChart) {
      this.holidayChart.update();
    }
  }

  compileSickBank(currentYearUsedBank: any) {
    let date = new Date();
    let sickOverlap = this.getOverlapDetails(this.selectedYear!).sickOverLap;

    if (this.sickBank && this.selectedYear) {
      this.sickUsed = this.sickBank.taken - this.usedBank[BankType.Sick];
      this.sickCarried = this.sickBank.carried + sickOverlap;

      if (this.selectedYear <= date.getFullYear()) {
        this.sickEntitlement = this.sickBank.allocated;
        this.sickRemaining = Number(
          (this.sickEntitlement + this.sickCarried - this.sickUsed).toFixed(2)
        );
      } else {
        // first set the default variables for the current year
        sickOverlap = this.getOverlapDetails(date.getFullYear()).sickOverLap;

        let carried = this.sickBank.carried + sickOverlap;
        let used = this.sickBank.taken - currentYearUsedBank[BankType.Sick];
        this.sickEntitlement = this.sickBank.allocated;
        this.sickRemaining = Number(
          (this.sickBank.allocated + carried - used).toFixed(2)
        );

        // set the data entries for the selected year
        this.sickEntitlement = 0;
        this.sickUsed = 0 - this.usedBank[BankType.Sick];
        this.sickCarried = this.sickRemaining;
        this.sickRemaining = Number(
          (this.sickCarried + this.usedBank[BankType.Sick]).toFixed(2)
        );
      }
    }

    this.sickChartData.datasets[0].data = [this.sickUsed, this.sickRemaining];
    if (this.sickChart) {
      this.sickChart.update();
    }
  }

  updateCharts() {
    if (this.cdoChart) {
      this.cdoChart.update();
    }
    if (this.holidayChart) {
      this.holidayChart.update();
    }
    if (this.sickChart) {
      this.sickChart.update();
    }
  }
  toggleSummary() {
    this.isCollapse = !this.isCollapse;
    if (!this.isCollapse) {
      this.updateCharts();
    }
  }

  dayOfPayPeriod(year: number, month: number, day: number): number {
    const f = new Date(1970, 0, 3);
    const d = new Date(year, month, day);
    const diff = d.getTime() - f.getTime();
    return Math.round(diff / (1000 * 3600 * 24)) % 14;
  }

  addDays(original: Date, days: number) {
    const date = new Date(original.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }
}
